import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import Collapse from "../Collapse/Collapse";
const ActionBar = (props) => {
    const [currentAction, setCurrentAction] = React.useState(null);
    const closeAction = React.useMemo(() => () => setCurrentAction(null), []);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "d-flex mb-2", children: props.actions.map((action, index) => {
                    const button = (_jsxs("button", { className: classNames("btn mr-2 btn-link", {
                            "pl-0": index === 0,
                        }), 
                        // @ts-expect-error - TS2322 - Type 'string | boolean | null | undefined' is not assignable to type 'boolean | undefined'.
                        disabled: action.disabled, onClick: () => {
                            if (currentAction === index) {
                                setCurrentAction(null);
                            }
                            else {
                                setCurrentAction(index);
                            }
                        }, children: [action.icon, action.title] }, index));
                    return typeof action.disabled === "string" ? (_jsx("div", { title: action.disabled, children: button })) : (button);
                }) }), props.actions.map((action, index) => (_jsx(Collapse, { open: currentAction === index, unMountChildren: true, children: _jsx("div", { className: "card border bg-light card-body", children: typeof action.body === "function"
                        ? action.body(closeAction)
                        : action.body }) }, index)))] }));
};
export default ActionBar;
